"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function cancelAnimationFrame(handler) {
  var method = window.cancelAnimationFrame || window.webkitCancelAnimationFrame || // @ts-ignore
  window.mozCancelAnimationFrame || // @ts-ignore
  window.msCancelAnimationFrame || clearTimeout;
  method(handler);
}

exports.default = cancelAnimationFrame;
;